import _ from 'lodash';
import multiMixin from 'privates/utils/multiMixin';
import * as members from 'privates/privateMembers';
import BackgroundColorMixin from './BackgroundColorMixin';
import BorderWidthMixin from './BorderWidthMixin';
import BorderColorMixin from './BorderColorMixin';
import BorderRadiusMixin from './BorderRadiusMixin';
import TextColorMixin from './TextColorMixin';
import monitoring from 'privates/monitoring';

const SUPPORTED_STYLES = {
    Button: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Box: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype],
    Checkbox: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype],
    UploadButton: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    TextInput: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    TextBox: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Shape: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype],
    RadioButtonGroup: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    CheckboxGroup: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Header: [BackgroundColorMixin.prototype, BorderColorMixin.prototype],
    Footer: [BackgroundColorMixin.prototype, BorderColorMixin.prototype],
    Dropdown: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype]
};

function getRavenContextForStyle(){
    const RMI = members._RMI.get(this);
    const compId = members._compId.get(this);
    const type = members._type.get(this);
    const compNickname = members._compName.get(this);

    return {compId, type, compNickname, RMI};
}


const styleClasses = _.transform(SUPPORTED_STYLES, (result, styleMixins, compType) => {

    /**
     * @class Style
     * @memberOf $w
     * @summary An object representing an element's styles.
     */
    class Style {
        constructor(RMI, compId, type, compNickname) {
            members._RMI.set(this, RMI);
            members._compId.set(this, compId);
            members._type.set(this, type);
            members._compName.set(this, compNickname);
        }
    }

    multiMixin(Style.prototype, styleMixins);

    result[compType] = monitoring.monitorClass(Style, getRavenContextForStyle);
}, {});



/**
 * @class StyleMixin
 * @summary Provides functionality for elements that can be styled.
 * @classdesc
 *  Elements that expose a [`style`](#style) property can be styled programmatically.
 *  You cannot programmatically style elements that do no expose a [`style`](#style) property.
 * @memberof $w
 * @tagname styleMixin
 */
class StyleMixin {
    /**
     * @member style
     * @label property
     * @syntax
     * get style(): Style
     * @summary Gets an object containing information about the element's styles.
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {$w.Style}
     * @memberof $w.StyleMixin
     * @readonly
     */
    get style() {
        let styleInstance = members._styleInstance.get(this);
        if (styleInstance) {
            return styleInstance;
        }

        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const type = members._type.get(this);
        const StyleClass = styleClasses[type.compType];
        const compName = this.id;

        styleInstance = new StyleClass(RMI, compId, type, compName);
        members._styleInstance.set(this, styleInstance);
        return styleInstance;
    }
}

export default StyleMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/styleMixins/StyleMixin.es6